import { Box, Flex, Text } from "@chakra-ui/react";
import { Message } from "../types/Message.type";
import { useCurrentUser } from "hooks/auth";
import dayjs from "newui/utils/dayjs";
import SkeletonBase from "newui/components/Skeleton";
import { MessageFileList } from "./MessageFileList";
import { useMemo } from "react";
import Tooltip from "components/Tooltip";

interface MessageBubbleProps {
	isLoading: boolean;
	message: Message;
}

/**
 * Displays the given message
 * @param param0
 * @returns
 */
export const MessageBubble: React.FC<MessageBubbleProps> = ({
	isLoading,
	message,
}) => {
	const { currentUser } = useCurrentUser();
	const isOwnMessage = message.sender_user_id === currentUser.id;

	const createdAt = dayjs(message?.created_at).format(
		"ddd DD MMM, YYYY h:mm A"
	);

	const getDisplayValue = (value: string) => {
		if (value?.length > 20) {
			const trimmedValue = value.substring(0, 17);
			return <Tooltip label={value}>{trimmedValue}...</Tooltip>;
		}

		return value;
	};

	const senderName = useMemo(() => {
		return getDisplayValue(message?.sender_name);
	}, [message?.sender_name]);

	const companyName = useMemo(() => {
		return getDisplayValue(message?.sender_company_name || "Guest User");
	}, [message?.sender_company_name]);

	return (
		<Flex
			justify={isOwnMessage ? "flex-end" : "flex-start"}
			mb={3}
		>
			<Box
				className={`max-w-[70%] rounded-lg px-3 py-2 ${isOwnMessage ? "bg-gray-100" : "bg-blue-100"}`}
			>
				{isLoading ? (
					<SkeletonBase />
				) : (
					<>
						{" "}
						<div className="text-xs text-gray-500">
							{senderName} - {companyName}
						</div>
						<Box
							className="prose prose-sm"
							dangerouslySetInnerHTML={{ __html: message.body }}
						/>
						<MessageFileList files={message.files} />
						<Text
							fontSize="xs"
							color="gray.400"
							textAlign="right"
						>
							{createdAt}
						</Text>
					</>
				)}
			</Box>
		</Flex>
	);
};
